
<div class="modal fade" id={{modelId}}  tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                           Delete {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal">
                </div>
                <hr>
                <div>
                    <div class="modal-text">
                        Are you sure you want to delete the {{modalName}} 
                        <span style="font-weight: bold;">{{title}}</span><br/>
                        This action cannot be undone.
                    </div>
             
                    <div class="modal-sub-text " *ngIf='modalName == "Integration"' >
                        Deleting the integration will affect related Categories, Items, and Outlets.

                    </div>  
                    <div class="modal-sub-text " *ngIf='modalName == "Franchise"' >
                        Deleting the franchise will affect related Outlets, POS, Categories, Delivery integrations, Items, and Main menu.
                    </div>
                    <div class="modal-sub-text" *ngIf='modalName == "Outlet"' >
                        Deleting the outlet will affect related POS, Categories, Delivery integrations, Items, and Main menu.

                    </div>
                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-delete-button" type="button" (click)="onDelete()">
                        <span *ngIf="!loading">Delete</span>
                        <div *ngIf="loading" style="position: absolute;">
                            <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff" type="ball-clip-rotate"
                              [fullScreen]="false"></ngx-spinner>
                          </div>
                    </button> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


